import * as _ from 'lodash'
import valueFilters from '../valueFilters';
import validator from '../validator';
import modelFactory, { IModel } from '../modelFactory';
import model from './model';

export interface IPhoneNumber extends IModel {
	type?: number;
	number: string;
}

const phoneNumberFactory = modelFactory.createFactory<IPhoneNumber>('PhoneNumber', _.assign({}, model, {
	type: {
		setFilters: valueFilters.toNumber,
		rules: validator.enum('phoneNumberTypes', true) // disallow 0
	},
	number: {
		setFilters: valueFilters.toString,
		rules: validator.phone(false) // do not allow undefined
	}
}));

export default phoneNumberFactory;